import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'primeng/fileupload';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NotificationsService } from '../service/notifications.service';
import { Notification } from '../model/notification';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { TippyDirective } from '@ngneat/helipopper';
import { CustomShopSelectorComponent } from "../../import/catalog-import/shared/custom-shop-selector/custom-shop-selector.component";
import { SelectButtonModule } from 'primeng/selectbutton';
import { Stepper, StepItem, Step, StepPanel } from 'primeng/stepper';
import { Util } from '../../../utils/util';
import { ListboxModule } from 'primeng/listbox';
import { ShopService } from '../../shop/service/shop.service';
import { DatePickerModule } from 'primeng/datepicker';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  standalone: true,
  styleUrls: ['./notifications.component.scss'],
  imports: [
    CardModule,
    TranslateModule,
    ButtonModule,
    TableModule,
    DialogModule,
    RippleModule,
    ToastModule,
    ToolbarModule,
    ConfirmDialogModule,
    InputTextModule,
    TextareaModule,
    CommonModule,
    FileUploadModule,
    SelectModule,
    TagModule,
    RadioButtonModule,
    RatingModule,
    InputTextModule,
    FormsModule,
    InputNumberModule,
    ToggleButtonModule,
    TooltipModule,
    TippyDirective,
    CustomShopSelectorComponent,
    SelectButtonModule,
    Stepper, StepItem, Step, StepPanel,
    ListboxModule,
    DatePickerModule,
    IconFieldModule,
    InputIconModule
],
  providers: [MessageService, ConfirmationService],
})
export class NotificationsComponent implements OnInit {
  notifDialog: boolean = false;

  notifications!: Notification[];

  notif;

  selectedNotifications!: [] | null;

  submitted: boolean = false;

  statuses = ['ACTIVE', 'NOT_ACTIVE'];

  notifTypes = ['INFO', 'WARN', 'ERROR'];

  isNewNotification = false;
  checked: boolean = false;
  loading = true;
  options: any[] = [
    { label: 'notification.allUser', value: 'allUsers', id: 'allUsers' },
    { label: 'notification.allSellers', value: 'allSellers', id: 'allSellers' },
    { label: 'notification.allOperators', value: 'allOperators', id: 'allOperators' },
    { label: 'notification.oneUser', value: 'user', id: 'user' },
    { label: 'notification.shopUser', value: 'shopUsers', id: 'shopUsers' },
  ];
  selectedOption: string;
  selectedShopCode : string;
  aggregators = [];
  selectedAggregator;
  minDate = new Date()
  activeStep: number = 1;

  constructor(
    private readonly notificationService: NotificationsService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService,
    private readonly shopService: ShopService,
  ) {}

  ngOnInit() {
    this.getNotifications();
    this.loadAggregators();
  }

  getNotifications() {
    this.notificationService.getAllNotifications().subscribe({
      next: (response: Notification[]) => {
        this.notifications = response;
        this.loading = false
      },
    });
  }
   
  loadAggregators() {
    this.shopService.findAllAggregators().subscribe({
      next: (res: any[]) => {
        this.aggregators = res;
      },
    });
  }

  openAddNewNotif() {
    this.notif = {};
    this.submitted = false;
    this.isNewNotification = true;
    this.notifDialog = true;
  }

  editNotification(notif) {
    this.notif = { ...notif };
    this.isNewNotification = false;
    this.notifDialog = true;
  }
  deleteNotification(notif: Notification) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' + notif.title + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () =>
        this.notificationService
          .deleteNotification(notif.notificationCode)
          .subscribe({
            next: () => {
              this.showSuccessMessage();
              this.getNotifications();
            },
            error: () => {
              this.showErrorMessage();
            },
          }),
    });
  }
  getSeverity(status: string) {
    switch (status) {
      case 'ACTIVE':
        return 'success';
      case 'NOT_ACTIVE':
        return 'danger';
      default:
        return 'success';
    }
  }

  hideDialog() {
    this.notifDialog = false;
    this.submitted = false;
    this.notif = {}
    this.selectedShopCode = undefined;
    this.selectedOption = undefined;
    this.selectedAggregator = undefined;
  }

  onFilterChange(event: Event, dt: any) {
    const target = event.target as HTMLInputElement;
    if (target) {
      dt.filterGlobal(target.value, 'contains');
    }
  }

  CreateUpdateNotification() {
    if(this.notif?.endDate) {
      this.notif.endDate = this.notif.endDate.toLocaleString('fr-FR')
    }
    
    if (this.isNewNotification) {
      this.createNotification();
    } else {
      this.notificationService.updateNotification(this.notif).subscribe({
        next: (response) => {
          if(response['success']) {
            this.handleSuccessRequest()
          } else {
            this.showErrorMessage();
          }
          
        },
        error: () => {
          this.showErrorMessage();
        },
      });
    }
  }

  createNotification() {
    if(this.selectedOption === 'user') {
       this.notificationService.createAggregatorNotification(this.notif, this.selectedAggregator.aggregatorCode).subscribe({
        next: (response) => {
          if(response['success']) {
            this.handleSuccessRequest()
          } else {
            this.showErrorMessage();
          }
        },
        error: () => {
          this.showErrorMessage();
        },
      });
    }else if(this.selectedOption === 'shopUsers') {
      this.notificationService.createShopNotification(this.notif, this.selectedShopCode).subscribe({
        next: (response) => {
          if(response['success']) {
            this.handleSuccessRequest()
          } else {
            this.showErrorMessage();
          }
        },
        error: () => {
          this.showErrorMessage();
        },
      });
    }else {
      this.notif.isForAllUsers = this.selectedOption === 'allUsers'
      this.notif.isForAllSellers = this.selectedOption === 'allSellers'
      this.notif.isForAllOperators = this.selectedOption === 'allOperators'
      this.notificationService.createNotification(this.notif).subscribe({
        next: (response) => {
          if(response['success']) {
            this.handleSuccessRequest()
          } else {
            this.showErrorMessage();
          }
        },
        error: () => {
          this.showErrorMessage();
        },
      });
    }
  }
  handleSuccessRequest() {
    this.showSuccessMessage();
    this.getNotifications();
    this.hideDialog();
  }

  showSuccessMessage() {
   Util.showSuccessMessage(this.messageService, this.translate)
  }
  showErrorMessage() {
    Util.showErrorMessage(this.messageService, this.translate)
  }

  updateSelectedShop(shop) {
    this.selectedShopCode = shop.shopCode;
  }
}
